export const ACHIEVEMENTS = [
    {
        id: 'STOCKPILE_HERO',
        name: 'The Granary Overfloweth',
        description: 'Stockpile 200 units of Water and 299 units of Food.',
        condition: (state) => state.resources.water >= 200 && state.resources.food >= 299
    },
    {
        id: 'DEFENSIVE_MONOLITH',
        name: 'The Aegis Protocol',
        description: 'Reach a Compound Defense level of 12.',
        condition: (state) => state.resources.defense >= 12
    },
    {
        id: 'morale_peak',
        name: "Perfect Unit Solidarity",
        description: "Achieve 100% morale through effective leadership and resource management.",
        condition: (state) => state.resources.morale >= 100
    },
    {
        id: 'FUEL_EMPIRE',
        name: 'Petrodollar Protocol',
        description: 'Stockpile 100 units of Fuel.',
        condition: (state) => state.resources.fuel >= 100
    },
    {
        id: 'TIME_VETERAN',
        name: 'The Eternal Commander',
        description: 'Complete 10 survival timelines.',
        condition: (state) => state.legacy.timelineCount >= 10
    },
    {
        id: 'MEDIC_LEGACY',
        name: 'Suture Specialist',
        description: 'Stockpile 30 units of Medical Supplies.',
        condition: (state) => state.resources.meds >= 30
    },
    {
        id: 'PACIFIC_SHELTER',
        name: 'The Golden Citadel',
        description: 'Reach Day 30 with zero unit casualties.',
        condition: (state) => state.day >= 30 && state.deceased.length === 0
    },
    {
        id: 'MASTER_COMMANDER',
        name: 'Architect of the New World',
        description: 'Reach Mastery Level 5.',
        condition: (state) => state.legacy.masteryLevel >= 5
    }
];
